var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewComboLg = function SvgViewComboLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61 42.375V5.625H20.5v36.75zm21.86 0V5.625h14.89v36.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61 42.375V5.625H20.5v36.75z"
  })));
};
export default SvgViewComboLg;